<template>
  <div class="hidden" />
</template>

<script setup lang="ts">
import { onMounted } from 'vue'
import { getUrlParam, getTemplateData } from '@/utils'
import { useThemeStore, useBundleStore, useProductsStore } from '@/stores'
import { useFueled } from '@/services/fueled'
import ProductModalWrapper from '@/components/products/product-modal-wrapper.vue'

const { modal } = useThemeStore()
const bundle = useBundleStore()
const productsStore = useProductsStore()
const variant = getUrlParam('variant')
const { productViewed } = useFueled()

if (variant) {
  const mapping = getTemplateData('#json-variant-map')?.[variant]
  if (mapping) {
    bundle.setSelectedSize(mapping.size)
    bundle.plan = mapping.plan
  }
} else {
  bundle.readUrlParams()
}

const openPdpModal = () => {
  const hash = String(window.location.hash).slice(1)
  const product = hash.length && productsStore.productList.find(p => p.handle === hash)
  if (product) {
    productViewed(product)
    modal.open(ProductModalWrapper, { bundleProductId: product.bpId })
  }
}

window.addEventListener('replaceState', openPdpModal)
onMounted(openPdpModal)
</script>
